
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M25.001 28H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12.001l7 7v16a1 1 0 0 1-1 1Z",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 4v7h7.001",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.813 22.818a.727.727 0 0 1-.727-.728v-5.313c0-.402.325-.727.727-.727h3.606c1.767 0 2.474.537 2.474 2.5v.752a.727.727 0 0 1-.727.727h-.339a.727.727 0 0 1-.727-.727v-.752c0-.471-.223-.654-.681-.654h-1.747a.727.727 0 0 0-.727.727v3.467a.727.727 0 0 1-.727.728h-.405Zm9-5.302c-.144 3.273-.93 5.407-4.622 5.407-.35 0-1.066-.037-1.588-.067a.723.723 0 0 1-.678-.66l-.217-2.489a.727.727 0 0 1 .724-.79h.25c.379 0 .695.291.724.67l.071.9a.713.713 0 0 0 .634.658c.134.013.255.023.316.023 2.16 0 2.33-1.256 2.422-3.927l.01-.48a.727.727 0 0 1 .727-.711h.538c.417 0 .748.35.726.766l-.038.7Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.001 28H7C6.44772 28 6 27.5523 6 27V5C6 4.44772 6.44772 4 7 4H19.001L26.001 11V27C26.001 27.2652 25.8956 27.5196 25.7081 27.7071C25.5205 27.8946 25.2662 28 25.001 28Z\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M19 4V11H26.001\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.8132 22.8178C11.4115 22.8178 11.0859 22.4922 11.0859 22.0905V16.7771C11.0859 16.3754 11.4115 16.0498 11.8132 16.0498H15.419C17.1863 16.0498 17.8932 16.5865 17.8932 18.5502V19.3022C17.8932 19.7038 17.5676 20.0294 17.1659 20.0294H16.827C16.4254 20.0294 16.0998 19.7038 16.0998 19.3022V18.5502C16.0998 18.0789 15.8772 17.8956 15.419 17.8956H13.6721C13.2705 17.8956 12.9448 18.2212 12.9448 18.6229V22.0905C12.9448 22.4922 12.6192 22.8178 12.2176 22.8178H11.8132ZM20.8125 17.516C20.6685 20.7887 19.883 22.9225 16.1914 22.9225C15.8412 22.9225 15.1254 22.8855 14.6025 22.8555C14.2438 22.8349 13.956 22.5534 13.9247 22.1955L13.7076 19.7072C13.6706 19.2822 14.0055 18.9167 14.4322 18.9167H14.6813C15.0609 18.9167 15.3766 19.2085 15.4064 19.5869L15.4773 20.4871C15.5044 20.8305 15.7686 21.1098 16.1114 21.1446C16.2452 21.1582 16.3659 21.1684 16.427 21.1684C18.587 21.1684 18.7572 19.9116 18.8488 17.2411L18.8594 16.7611C18.8681 16.3658 19.1911 16.0498 19.5865 16.0498H20.1238C20.5407 16.0498 20.8723 16.3996 20.85 16.816L20.8125 17.516Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/account.58355d09da30243188a0b582a1ea841a.svg"),
        {
          React: SvgAccount,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      